import Temp from "@/courier/Temp";

export default class BestExpress extends Temp {
  static CODE = "BEST";

  constructor() {
    super(BestExpress.CODE);
  }

  getZone(item) {
    let type, from, to;
    let cross_price = 0;
    let remote_area = 0;

    remote_area = super.checkRemoteArea(Number(item.toPostcode));

    from = super.checkZone(item.fromPostcode);
    to = super.checkZone(item.toPostcode);

    // หลังจาก deploy ก็ลบ if ใช้ในส่วน else เอานะครับ
    let dateNow = new Date();
    let startPromotion13012022 = new Date("2022-01-13 00:00:01");
    if (dateNow < startPromotion13012022) {
      if (from == 1 && to == 1) {
        // BKK -> BKK
        type = 1;
      } else if (from == to) {
        // จังหวัดเดียวกันที่ไม่ใช่ BKK
        type = 3;
      } else if (from == 1) {
        // BKK -> ตจว
        type = 2;
      } else if (from != 1 && to == 1) {
        // ตจว -> BKK
        type = 4;
      } else {
        // ต่างภาค
        type = 5;
      }
    } else {
      if (from == 1 && to == 1) {
        type = 1;
      } else if (from == 1 && to != 1) {
        type = 2;
      } else if (from != 1 && to == 1) {
        type = 3;
      } else {
        // ต่างจังหวัด -> ต่างจังหวัด :)
        type = 4;
      }
    }
    return {
      rate_type: type,
      rate_remote_area: remote_area,
      cross_price: cross_price,
    };
  }

  checkWeight(courierRates, item, validate) {
    item.index = courierRates.findIndex((rate) => {
      return item.weight >= rate.min && item.weight <= rate.max;
    });

    return super.checkRules(item, validate);
  }

  checkDimension(dimensionCourier, item, validate) {
    return super.checkCourierDimension(dimensionCourier, item, validate);
  }

  async checkRemoteAreaByCorrectorDest(addressRemote) {
    return new Promise((resolve) => {
      super.getRemoteArea(addressRemote).then((res) => {
        if (
          res.status === 1 &&
          (res.data.hasOwnProperty("isRemote") ||
            res.data.hasOwnProperty("isIsland") ||
            res.data.hasOwnProperty("isRemote100")) &&
          (res.data.isRemote.includes("best") ||
            res.data.isIsland.includes("best") ||
            res.data.isRemote100.includes("best"))
        ) {
          resolve(true);
        } else if (res.status === 0 && res.data.length === 0) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }
}
